import React from "react";
import "./Share.css";
import {
  FacebookIcon,
  FacebookShareButton,
  InstapaperIcon,
  InstapaperShareButton,
  LineIcon,
  LineShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  PinterestIcon,
  PinterestShareButton,
  RedditIcon,
  RedditShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";

function Share() {
  const URL = "https://squidgamefacetest.netlify.app/";
  const mediaAbsLink =
    "https://img1.daumcdn.net/thumb/R1280x0/?scode=mtistory2&fname=https%3A%2F%2Fblog.kakaocdn.net%2Fdn%2FlszTj%2FbtripwAh7x1%2FZCKbMU1ae8MvNzIIrMLiUK%2Fimg.png";
  return (
    <div className="Share">
      <div className="share-text">Share the Test</div>
      <div>
        <FacebookShareButton
          className="socialBtn"
          url={URL}
          quote={"Who do I look like in Squid Game?"}
          hashtag={"squid game"}
        >
          <FacebookIcon size={30} round />
        </FacebookShareButton>
        <TwitterShareButton
          className="socialBtn"
          url={URL}
          quote={"Who do I look like in Squid Game?"}
          hashtag={"squid game"}
        >
          <TwitterIcon size={30} round />
        </TwitterShareButton>
        <RedditShareButton
          className="socialBtn"
          url={URL}
          quote={"Who do I look like in Squid Game?"}
          hashtag={"squid game"}
        >
          <RedditIcon size={30} round />
        </RedditShareButton>
        <LineShareButton
          className="socialBtn"
          url={URL}
          quote={"Who do I look like in Squid Game?"}
          hashtag={"squid game"}
        >
          <LineIcon size={30} round />
        </LineShareButton>
        <LinkedinShareButton
          className="socialBtn"
          url={URL}
          quote={"Who do I look like in Squid Game?"}
          hashtag={"squid game"}
        >
          <LinkedinIcon size={30} round />
        </LinkedinShareButton>

        <PinterestShareButton
          className="socialBtn"
          url={URL}
          quote={"Who do I look like in Squid Game?"}
          hashtag={"squid game"}
          media={mediaAbsLink}
        >
          <PinterestIcon size={30} round />
        </PinterestShareButton>

        <WhatsappShareButton
          className="socialBtn"
          url={URL}
          quote={"Who do I look like in Squid Game?"}
          hashtag={"squid game"}
        >
          <WhatsappIcon size={30} round />
        </WhatsappShareButton>
        <InstapaperShareButton
          className="socialBtn"
          url={URL}
          quote={"Who do I look like in Squid Game?"}
          hashtag={["squid game", "squid game face test"]}
        >
          <InstapaperIcon size={30} round />
        </InstapaperShareButton>
      </div>
    </div>
  );
}

export default Share;
